import React, { useState, useEffect } from "react";
import axios from "axios";
// import Navbar from "../NavBar";
// import "./DealsPage.css";
import DealsFilter from "./Dealsfilters";
import CustomNavbar from "../CustomPermissions/CustomNavbar";
import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";
import { fetchDeals as apiFetchDeals, deleteDeal, createDeal, updateDeal } from "./api";

// import "../MarketingForm.css";

const DealsPage = () => {
  const [deals, setDeals] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const [editingDeal, setEditingDeal] = useState(null);
  const [formData, setFormData] = useState({});
  const [filteredDeals, setFilteredDeals] = useState([]);
  const [dealLength, setDealLength] = useState(0);
  const [filters, setFilters] = useState({
    deal_name: "",
    deal_status: "",
    percentage: "",
    hospital_name: "",
  });

  useEffect(() => {
    fetchDeals();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, deals]);

  const applyFilters = () => {
    let filtered = deals.filter((deal) => {
      return (
        deal.deal_name
          .toLowerCase()
          .includes(filters.deal_name.toLowerCase()) &&
        deal.deal_status
          .toLowerCase()
          .includes(filters.deal_status.toLowerCase()) &&
        deal.hospital_name
          .toLowerCase()
          .includes(filters.hospital_name.toLowerCase()) &&
        (filters.percentage === "" || deal.percentage == filters.percentage)
      );
    });
    // Sort by date (latest first)
    filtered.sort((a, b) => {
      const dateA = new Date(a.deal_date);
      const dateB = new Date(b.deal_date);
      return dateB - dateA; // Latest first
    });
    setFilteredDeals(filtered);
  };

  const fetchDeals = async () => {
    try {
      const response = await apiFetchDeals();
      setDeals(response.data);
      setDealLength(response.data.length);
    } catch (error) {
      console.error("Error fetching deals:", error);
      if (error.response && error.response.status === 401) {
        alert("Session expired. Please log in again.");
      }
    }
  };

  const handleEdit = (deal) => {
    setEditingDeal(deal);
    setFormData(deal);
    setModalShow(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this deal?")) {
      try {
        await deleteDeal(id);
        alert("Deal deleted successfully");
        fetchDeals();
      } catch (error) {
        console.error("Error deleting deal:", error);
        alert("Failed to delete deal. Please try again.");
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formPayload = new FormData();
    Object.keys(formData).forEach((key) => {
      formPayload.append(key, formData[key]);
    });
    if (editingDeal) {
      try {
        await updateDeal(editingDeal.id, formPayload);
        alert("Deal updated successfully");
      } catch (error) {
        console.error("Error updating deal:", error);
        alert("Failed to update deal. Please try again.");
      }
    } else {
      try {
        await createDeal(formPayload);
        alert("Deal created successfully");
      } catch (error) {
        console.error("Error creating deal:", error);
        alert("Failed to create deal. Please try again.");
      }
    }
    setModalShow(false);
    fetchDeals();
    setFormData({
      deal_name: "",
      deal_description: "",
      deal_status: "",
      deal_date: "",
      hospital_name: "",
      concern_person: "",
      concern_person_contact: "",
      concern_person_email: "",
      payment_terms: "",
      percentage: "",
      deal_attachment: null,
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const toggleRowExpansion = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const resetFormData = () => {
    setFormData({
      deal_name: "",
      deal_description: "",
      deal_status: "",
      deal_date: "",
      hospital_name: "",
      concern_person: "",
      concern_person_contact: "",
      concern_person_email: "",
      payment_terms: "",
      percentage: "",
      deal_attachment: null,
    });
  };

  const closeModal = () => {
    setModalShow(false);
    resetFormData(); // Reset form data
    setEditingDeal(null); // Clear editing state
  };

  return (
    <div style={{ display: "flex" }}>
      <CustomNavbar />
      <div
        style={{
          width: "90vw",
          margin: "0 auto",
          padding: "15px",
          // boxShadow: "5px 10px #888888",
        }}
      >
        <div
          className="container mt-3 mb-2"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h1 className="text-center text-5xl text-blue-500 mb-2">
            Deals Management
          </h1>
          <button
            className="bg-blue-500 text-white px-4 py-2 mb-2 rounded hover:bg-blue-900 transition-colors"
            onClick={() => setModalShow(true)}
          >
            Add New Deal
          </button>
        </div>
        <div className="mt-3">
          <DealsFilter filters={filters} setFilters={setFilters} />
        </div>
        <div className="">
          <div className="table-responsive">
            <table className="tables table-hover">
              <thead className="">
                <tr>
                  <th colSpan="8" className="bg-white text-dark">Current Deals: {dealLength}</th>
                </tr>
                <tr style={{ width: "100vw" }} className="bg-blue-500">
                  <th style={{ width: "5vw" }}>Sr. No.</th>
                  <th style={{ width: "20vw" }}>Deal Name</th>
                  <th style={{ width: "10vw" }}>Deal Date</th>
                  <th style={{ width: "20vw" }}>Hospital</th>
                  <th style={{ width: "10vw" }}>Payment Terms</th>
                  <th style={{ width: "10vw" }}>Percentage</th>
                  <th style={{ width: "5vw" }}>Status</th>
                  <th style={{ width: "20vw" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredDeals.map((deal, index) => (
                  <React.Fragment key={deal.id}>
                    <tr
                      className="clickable-row text-center"
                      onClick={() => toggleRowExpansion(deal.id)}
                      style={{
                        borderBottom: "1px solid rgba(0,0,0,0.1)",
                        fontSize: "14px",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{deal.deal_name}</td>
                      <td>{deal.deal_date}</td>
                      <td>{deal.hospital_name}</td>
                      <td>{deal.payment_terms ? deal.payment_terms.slice(0, 30) : "N/A"}</td>
                      <td>{deal.percentage || "N/A"}</td>
                      <td>{deal.deal_status}</td>
                      <td style={{ padding: "5px", paddingTop: "20px" }}>
                        {deal.deal_attachment ? (
                          <>
                            <a
                              href={`${API_BASE_URL}${deal.deal_attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-info me-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-eye-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                              </svg>
                            </a>
                          </>
                        ) : (
                          <>
                            <button
                              className="btn me-2"
                              style={{
                                color: "white",
                                backgroundColor: "gray",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-eye-slash-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                              </svg>
                            </button>
                          </>
                        )}

                        <button
                          className="btn btn-warning me-2"
                          onClick={() => handleEdit(deal)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                              fill-rule="evenodd"
                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                          </svg>
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleDelete(deal.id)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-archive-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8z" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                    {expandedRow === deal.id && (
                      <tr className="expanded-row ">
                        <td colSpan="8">
                          <div
                            className="expanded-content"
                            style={{
                              padding: 20,
                              backgroundColor: "#E7E5E4",
                              textAlign: "left",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>
                                <strong>Concern Person:</strong>{" "}
                                {deal.concern_person}
                              </span>{" "}
                              <span>
                                <strong>Contact:</strong>{" "}
                                {deal.concern_person_contact || "N/A"}
                              </span>{" "}
                              <span>
                                <strong>Email:</strong>{" "}
                                {deal.concern_person_email || "N/A"}
                              </span>{" "}
                            </div>
                            <div className="mt-3">
                              <strong>Description:</strong>{" "}
                              {deal.deal_description}{" "}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            {modalShow && (
              <div className="fixed inset-0 flex justify-center items-center z-50">
                {/* Backdrop */}
                <div
                  className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
                  style={{
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    overflowY: "hidden",
                  }}
                ></div>

                {/* Modal Content */}
                <div
                  className="relative bg-white rounded-lg shadow-lg"
                  style={{
                    maxWidth: "800px", // Maximum width for larger screens
                    height: "auto", // Auto height to fit content
                    maxHeight: "90vh", // Maximum height to avoid overflowing the viewport
                    margin: "auto",
                    paddingBottom: "100px",
                    overflowY: "auto",
                    transition: "width 0.3s, margin-left 0.3s", // Smooth transition
                  }}
                >
                  {/* Close Button */}
                  <button
                    onClick={closeModal}
                    className="absolute mr-3 top-2 text-2xl py-1 mt-3 border bg-gray-800 text-white right-2 p-2 text-gray-600 hover:text-gray-900 focus:outline-none"
                  >
                    X
                  </button>

                  <div
                    className="overflow-auto p-4 sm:p-6" // Responsive padding
                    style={{ paddingTop: "20px" }}
                  >
                    <h2 className="text-center text-blue-500 mb-5">Add File</h2>

                    {/* Form */}
                    <div className="modal-body">
                      <form
                        onSubmit={handleSubmit}

                      >
                        <div
                          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
                        >
                          <input
                            type="text"
                            name="deal_name"
                            placeholder="Deal Name"
                            className="w-full p-2 border rounded input-field"
                            value={formData.deal_name || ""}
                            onChange={handleChange}
                            required
                          />

                          <select
                            name="deal_status"
                            className="w-full p-2 border rounded input-field"
                            value={formData.deal_status || ""}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled>
                              Select Status
                            </option>
                            <option value="Active">Active</option>
                            <option value="In Active">In Active</option>
                          </select>

                          <input
                            type="date"
                            name="deal_date"
                            placeholder="Deal Date"
                            className="w-full p-2 border rounded input-field"
                            value={formData.deal_date || ""}
                            onChange={handleChange}
                            required
                          />

                          <input
                            type="text"
                            name="hospital_name"
                            placeholder="Hospital Name"
                            className="w-full p-2 border rounded input-field"
                            value={formData.hospital_name || ""}
                            onChange={handleChange}
                            required
                          />

                          <input
                            type="text"
                            name="concern_person"
                            placeholder="Concern Person"
                            className="w-full p-2 border rounded input-field"
                            value={formData.concern_person || ""}
                            onChange={handleChange}
                            required
                          />

                          <input
                            type="text"
                            name="concern_person_contact"
                            placeholder="Contact"
                            className="w-full p-2 border rounded input-field"
                            value={formData.concern_person_contact || ""}
                            onChange={handleChange}
                            required
                          />


                          <input
                            type="text"
                            name="percentage"
                            placeholder="Percentage"
                            className="w-full p-2 border rounded input-field"
                            value={formData.percentage || ""}
                            onChange={handleChange}
                          />

                          <input
                            type="email"
                            name="concern_person_email"
                            placeholder="Email"
                            className="w-full p-2 border rounded input-field"
                            value={formData.concern_person_email || ""}
                            onChange={handleChange}
                          />

                          <input
                            type="file"
                            name="deal_attachment"
                            placeholder="Attachment"
                            className="w-full p-2 border rounded input-field"
                            onChange={handleChange}
                          />

                          {/* <input
                          type="text"
                          name="payment_terms"
                          placeholder="Payment Terms"
                          className="w-full p-2 border rounded input-field"
                          value={formData.payment_terms || ""}
                          onChange={handleChange}
                          required
                        /> */}
                        </div>
                        <div style={{ width: "100%", height: "250px", zIndex: "4", display: 'flex', marginTop: "20px", gap: "10px" }}>
                          <textarea
                            name="payment_terms"
                            placeholder="Payment Terms"
                            className=" p-2 border rounded "
                            value={formData.payment_terms || ""}
                            onChange={handleChange}
                            style={{ width: "50%", height: "250px", zIndex: "4" }}

                          ></textarea>
                          <textarea
                            name="deal_description"
                            placeholder="Description"
                            className=" p-2 border rounded "
                            value={formData.deal_description || ""}
                            onChange={handleChange}
                            style={{ width: "50%", height: "250px", zIndex: "4" }}

                          ></textarea>
                        </div>
                        <br />
                        <div></div>

                        <div className="flex justify-end mt-4 md:col-span-2 lg:col-span-3">
                          <button
                            type="submit"
                            className="bg-blue-500 p-2 px-4 text-white rounded"
                          >
                            {editingDeal ? "Update" : "Create"} Deal
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealsPage;
